import { render, staticRenderFns } from "./QiDetailForm.vue?vue&type=template&id=0defb18e&scoped=true&"
import script from "./QiDetailForm.vue?vue&type=script&lang=ts&"
export * from "./QiDetailForm.vue?vue&type=script&lang=ts&"
import style0 from "./QiDetailForm.vue?vue&type=style&index=0&id=0defb18e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0defb18e",
  null
  
)

export default component.exports